export default __webpack_public_path__ + "static/media/EditFolderIcon.26732b69.svg";